import { render, staticRenderFns } from "./cpt-image-option.vue?vue&type=template&id=53e0dbb6&scoped=true"
import script from "./cpt-image-option.vue?vue&type=script&lang=js"
export * from "./cpt-image-option.vue?vue&type=script&lang=js"
import style0 from "./cpt-image-option.vue?vue&type=style&index=0&id=53e0dbb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e0dbb6",
  null
  
)

export default component.exports